import { useEffect, useRef } from 'react';
import { refreshCsrfToken } from 'utils/clients/csrf';

const MIN_REFRESH_INTERVAL_MS = 60 * 1000;

export const useRefreshCsrfOnTabActive = (enabled: boolean) => {
  const lastRefreshAtRef = useRef(0);

  useEffect(() => {
    if (!enabled) return;
    const onTabActive = () => {
      if (document.visibilityState !== 'visible') return;
      const now = Date.now();
      if (now - lastRefreshAtRef.current < MIN_REFRESH_INTERVAL_MS) return;
      lastRefreshAtRef.current = now;
      refreshCsrfToken();
    };
    document.addEventListener('visibilitychange', onTabActive);
    window.addEventListener('focus', onTabActive);
    return () => {
      document.removeEventListener('visibilitychange', onTabActive);
      window.removeEventListener('focus', onTabActive);
    };
  }, [enabled]);
};
